import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  De_signTherapyPrescriptionDocumentInput,
  useDeSignTherapyPrescriptionMutation as useDeSignTherapyPrescriptionMutationType,
} from "@/modules/patients/detail/prescription/de/services/__generated__/useDeSignTherapyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeSignTherapyPrescriptionMutation($input: De_signTherapyPrescriptionDocumentInput!) {
    de_signTherapyPrescriptionDocument(input: $input) {
      qesSigningResponse {
        requestId
        signingRequestUrl
      }
      errors {
        ... on SignDocumentMutationFailed {
          errorType
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignTherapyPrescriptionMutationType>, "variables"> & {
  id: De_signTherapyPrescriptionDocumentInput["id"]
}

const useDeSignTherapyPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignTherapyPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignTherapyPrescriptionMutation }
